// import apiClient from './client';

// export const customersAPI = {
//   getAll: () => apiClient.get('/customers/'),
//   getById: (id) => apiClient.get(`/customers/${id}/`),
//   create: (data) => apiClient.post('/customers/', data),
//   update: (id, data) => apiClient.put(`/customers/${id}/`, data),
//   delete: (id) => apiClient.delete(`/customers/${id}/`),
// };

// src/api/customers.js
import apiClient from './client';

export const customersAPI = {
  getAll: () => apiClient.get('/customers/'),
  getById: (id) => apiClient.get(`/customers/${id}/`),
  create: (data) => apiClient.post('/customers/', data),
  update: (id, data) => apiClient.put(`/customers/${id}/`, data),
  delete: (id) => apiClient.delete(`/customers/${id}/`),
};
